'use strict';

angular.module('mobile-apps').factory('MobileAppsCacheInterceptor', ['$q', '$cacheFactory',
    function ($q, $cacheFactory) {
        return {
            request: function (config) {
                //console.log('request in mobile apps interceptor', config);
                if(config)
                {
                    if(config.method === 'POST' || config.method === 'PUT' || config.method === 'DELETE')
                    {
                        var mobileAppsCache = $cacheFactory.get('MobileAppsCache');
                        if(mobileAppsCache)
                        {
                            var mobileAppsCacheResponse = mobileAppsCache.get(config.url);

                            if(mobileAppsCacheResponse)
                            {
                                console.log('Cleared MobileApps Cache');
                                mobileAppsCache.removeAll();
                            }
                        }
                    }
                }
                return config || $q.when(config);
            }
        };
    }]);
/*
angular.module('mobile-apps').config(['$httpProvider', function ($httpProvider) {
    $httpProvider.interceptors.push('MobileAppsCacheInterceptor');
}]);*/

//Mobile apps service used to communicate Mobile apps REST endpoints
angular.module('mobile-apps').factory('MobileApps', [
    '$resource',
    function ($resource) {
        return $resource(
            'v1/projects/:mobileAppId',
            {
                mobileAppId: '@_id'
            },
            {
                get:
                {
                    method:'GET',
                    cache: false
                },
                query:
                {
                    method:'GET',
                    cache: false,
                    isArray: true
                },
                queryByPage:
                {
                    method:'POST',
                    url : 'v1/projectsByPage',
                    cache: false
                },
                update:
                {
                    method: 'PUT',
                    cache: false
                },
                save:
                {
                    method: 'POST',
                    cache: false
                },
                remove:
                {
                    method: 'DELETE',
                    cache: false
                },
                getToken:
                {
                    method: 'GET',
                    url : 'v1/projects/:mobileAppId/getToken'
                },
                requestSettings:
                {
                    method: 'GET',
                    url : 'v1/projects/:mobileAppId/requestSettings'
                },
				syncApp:
                {
                    method: 'PUT',
                    url : 'v1/projects/:mobileAppId/syncApp/:syncAppId'
                },
				importSpreadsheet:
				{
					method: 'POST',
					url : 'v1/projects/:mobileAppId/import-spreadsheet'
				},
                getEntryKey: {
                    method: 'GET',
                    url: 'v1/projects/:mobileAppId/entry/:entryId/key',
                    cache: false
                }
            }
        );
    }
]);
